module.exports = __webpack_public_path__ + "static/media/proxxmu-hifi2.35f3c083.png";